import "core-js/modules/es6.object.assign";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { useDeprecatedComponentWarning } from '@nerdwallet/deprecate';
import { useIconProps } from '../useIconProps';

var Facebook = function Facebook(props) {
  useDeprecatedComponentWarning({
    component: 'Facebook'
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 2048"
  }, useIconProps(props)), /*#__PURE__*/React.createElement("path", {
    d: "M2048 128v1792q0 52-38 90t-90 38h-512v-796h256l43-295h-299V725q0-64 32.5-98t95.5-34h192V327q-86-14-210-14-206 0-314.5 104.5T1095 702v255H839v295h256v796H128q-52 0-90-38t-38-90V128q0-52 38-90t90-38h1792q52 0 90 38t38 90z"
  }));
};

Facebook.displayName = 'Facebook';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Facebook.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

export default Facebook;